/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import AccordingToProductFilter from './filter/AccordingToProductFilter';
import AccordingToProductTable from './table/AccordingToProductTable';

import styles from './styles.module.scss';
import { useAppContext } from 'providers/AppProvider';

export const incomeBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'analytics',
    url: '/analytics/revaluation/revaluation-invoice'
  },

  {
    label: 'revaluation_products',
    url: '/analytics/revaluation/revaluation-invoice'
  },

  {
    label: 'revaluation_goods',
    active: true
  }
];

const AccordingToProduct = () => {
  const { t } = useTranslation();
  const {
    config: { theme }
  } = useAppContext();
  const [generateTableData, setGeneratedTableData] = useState([]);
  const [savedValues, setSavedValues] = useState([]);
  const [getName, setGetName] = useState('');
  const [getBarcode, setGetBarcode] = useState('');

  const sumOfAllCost = generateTableData.reduce((acc: any, item: any) => {
    const allCost =
      item?.revaluation_amount === undefined ? 0 : +item.revaluation_amount;
    return acc + allCost;
  }, 0);

  return (
    <div>
      <PageBreadcrumb items={incomeBreadcrumbItems} />
      <div>
        <h2 className="mb-5">{t('revaluation_goods')}</h2>

        <AccordingToProductFilter
          setGeneratedTableData={setGeneratedTableData}
          savedValues={savedValues}
          setSavedValues={setSavedValues}
          setGetName={setGetName}
          setGetBarcode={setGetBarcode}
        />
        <AccordingToProductTable
          generateTableData={generateTableData}
          setGeneratedTableData={setGeneratedTableData}
          getName={getName}
          getBarcode={getBarcode}
        />

        <div
          className={
            theme === 'dark' ? styles.darkRevProdFooter : styles.revProdFooter
          }
        >
          <div className={styles.box}>
            <p className="mb-0 text-bold">{t('total_sale_amount')}</p>
            <span>{sumOfAllCost ?? 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordingToProduct;
